export const LARGE_SCREEN_WIDTH = 972;
export const LARGE_SCREEN_WIDTH_REM = '60.75rem';

export const BASE_URL = '/1/api';

export const RTL_LOCALES = ['ar', 'he'];
export const WEB_SECTION_ID = 'R12181';
